<template>
  <form autocomplete="off" class="form" v-on:submit.prevent="submit(form)">
    <div class="flex form-row">
      <div class="col-12">
        <label for="institution_name">School/Institution Name <span>*</span></label>
        <input id="institution_name" type="text" placeholder="School/Institution Name" name="institution_name"
               v-model="form.institution_name" v-validate="'required|max:100'">
        <span v-if="errors.has('institution_name')">{{ errors.first('institution_name') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-6">
        <label for="first_name">First Name <span>*</span></label>
        <input id="first_name" type="text" placeholder="First Name" name="first_name"
               v-model="form.first_name" v-validate="'required|max:100'">
        <span v-if="errors.has('first_name')">{{ errors.first('first_name') }}</span>
      </div>
      <div class="col-6">
        <label for="last_name">Last Name <span>*</span></label>
        <input id="last_name" type="text" placeholder="Last Name" name="last_name" v-model="form.last_name"
               v-validate="'required|max:100'">
        <span v-if="errors.has('last_name')">{{ errors.first('last_name') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-5">
        <label for="job_title">Job Title <span>*</span></label>
        <input id="job_title" type="text" placeholder="Job Title" name="job_title" v-model="form.job_title"
               v-validate="'required|max:100'">
        <span v-if="errors.has('job_title')">{{ errors.first('job_title') }}</span>
      </div>
      <div class="col-7">
        <label for="email">Email Address <span>*</span></label>
        <input id="email" type="text" placeholder="Email Address" name="email"
               v-model="form.email" v-validate="'required|email|max:100'">
        <span v-if="errors.has('email')">{{ errors.first('email') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-4">
        <label for="phone">Phone Number <span>*</span></label>
        <input id="phone" type="text" placeholder="Phone Number" name="phone"
               v-model="form.phone" v-validate="'required|max:20'">
        <span v-if="errors.has('phone')">{{ errors.first('phone') }}</span>
      </div>
      <div class="col-4">
        <label for="zip">Zip Code <span>*</span></label>
        <input id="zip" type="text" placeholder="Zip Code" name="zip" v-model="form.zip"
               v-validate="'required|regex:^\\d{5}(?:[-\\s]\\d{4})?$'">
        <span v-if="errors.has('zip')">{{ errors.first('zip') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-8">
        <label for="comments_questions">Comments/Questions</label>
        <textarea
            rows="6"
            wrap="hard"
            id="comments_questions"
            placeholder="Please enter any comments or questions"
            name="comments_questions"
            v-model="form.comments_questions"
            v-validate="'max:1000'"
        ></textarea>
        <span v-if="errors.has('comments_questions')">{{ errors.first('comments_questions') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-4">
        <vue-recaptcha
          name="recaptcha"
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          size="normal"
          sitekey="6LfPhpEUAAAAAJAGW-4YZYvuBzPg98qeYkKq8QJD"
          v-model="form.recaptcha"
          v-validate="'required|min:1'">
        </vue-recaptcha>
        <span v-if="errors.has('recaptcha')">{{ errors.first('recaptcha') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-2">
        <button class="body-8 btn" :disabled="pending || errors.any()">Submit</button>
      </div>
    </div>
  </form>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'ContactUsForm',
    components: {
      'vue-recaptcha': VueRecaptcha
    },
    props: {
      pending: {
        default: false,
        type: Boolean
      }
    },
    data() {
      return {
        form: {
          institution_name: null,
          first_name: null,
          last_name: null,
          job_title: null,
          email: null,
          phone: null,
          comments_questions: null,
          recaptcha: null,
        },
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            this.$refs.recaptcha.reset();
            this.$emit('submit', this.form);
          }
        })
      },
      onCaptchaVerified(recaptchaToken) {
        this.form.recaptcha = recaptchaToken;
      },
      onCaptchaExpired: function () {
        this.$refs.recaptcha.reset();
      }
    }
  };
</script>
